/* Python syntax, naming and code style support */

export const toValidIdentifier = txt => {
  return txt.trim().replace(/[^a-zA-Z_0-9]/g, '').replace(/^\d+/, '')
}

export const toValidClassName = txt => {
  txt = toValidIdentifier(txt)
  if (txt) txt = txt[0].toUpperCase() + txt.substr(1)
  return txt
}

export const toValidAttributeName = txt => {
  txt = toValidIdentifier(txt)
  if (txt) txt = txt[0].toLowerCase() + txt.substr(1)
  return txt
}



// WEBPACK FOOTER //
// ./src/helpers/python.js